import { CircleCheck } from "lucide-react";

type NotificationDrawerProps = {
  open: boolean;
  onClose: () => void;
};

const notifications = [
  "Activity Log Updated",
  "Account Deactivated Updated",
  "Notice Sent",
];

const NotificationDrawer = ({ open, onClose }: NotificationDrawerProps) => {
  return (
    <>
      {open && <div className="notification-backdrop" onClick={onClose}></div>}

      <div className={`notification-drawer ${open ? "show" : ""}`}>
        <div className="notification-header">
          <h5>Notification</h5>

          <button className="btn p-0" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="notification-body">
          {notifications.map((item, index) => (
            <div key={index} className="d-flex align-items-center gap-2 mb-4">
              <CircleCheck size={20} className="me-2 text-success" />
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default NotificationDrawer;
